// "use client";
import Script from "next/script";

const VTagLeadsy = () => {
	return (
		<Script
			id="vtag-ai-js"
			async
			src="https://r2.leadsy.ai/tag.js"
			data-pid="1kxlgWjrLWXekvDa1"
			data-version="062024"
			strategy="afterInteractive"
		/>
	);
};

export default VTagLeadsy;
